import apiClient from '@/services/axios'
import utilities from '@/services/utilities'

export async function createBill(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/billing/create', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function downloadBill(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/billing/download', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}
